import { useEffect } from 'react';
import { parse } from '../util/urlHelpers';
import { useDispatch } from 'react-redux';
import { TOGGLE_NOTIFICATION_FEED } from '../ducks/UI.duck';
import { NOTIFICATION_FEED_URL_STATE_OPEN_KEY } from '../customUserNotificationEvents-config';

export const useNotificationFeedParam = () => {
    const dispatch = useDispatch();

    const toggleNotificationFeed = payload => dispatch({ type: TOGGLE_NOTIFICATION_FEED, payload });

    useEffect(() => {
        const parsedLocationSearch = parse(window.location.search);

        const notificationFeedOpen = parsedLocationSearch[NOTIFICATION_FEED_URL_STATE_OPEN_KEY];

        if (notificationFeedOpen) {
            toggleNotificationFeed(true);
        }
    }, []);
};
